import { render, staticRenderFns } from "./certifications.vue?vue&type=template&id=6294af42&scoped=true"
import script from "./certifications.vue?vue&type=script&lang=js"
export * from "./certifications.vue?vue&type=script&lang=js"
import style0 from "./certifications.vue?vue&type=style&index=0&id=6294af42&prod&scoped=true&lang=css"
import style1 from "./certifications.vue?vue&type=style&index=1&id=6294af42&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6294af42",
  null
  
)

export default component.exports